import React, { useState } from 'react';
import { LockIcon } from 'lucide-react';
export function PaymentForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    whatsapp: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section className="max-w-lg mx-auto px-4 pb-6" data-id="element-55">
      <div className="bg-white rounded-2xl p-5 shadow-sm" data-id="element-56">
        <h3 className="text-lg font-semibold text-deep-cocoa mb-4" data-id="element-57">
          Completa tu información
        </h3>

        <form className="space-y-4" data-id="element-58">
          {/* Name Field */}
          <div data-id="element-59">
            <label htmlFor="name" className="block text-sm font-medium text-deep-cocoa mb-1.5" data-id="element-60">
              Nombre completo
            </label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Tu nombre" className="w-full px-4 py-3 bg-almond-milk border border-transparent rounded-lg text-deep-cocoa placeholder:text-deep-cocoa/40 focus:outline-none focus:ring-2 focus:ring-champagne-gold focus:border-transparent transition-all" required data-id="element-61" />
          </div>

          {/* Email Field */}
          <div data-id="element-62">
            <label htmlFor="email" className="block text-sm font-medium text-deep-cocoa mb-1.5" data-id="element-63">
              Correo electrónico
            </label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="tu@email.com" className="w-full px-4 py-3 bg-almond-milk border border-transparent rounded-lg text-deep-cocoa placeholder:text-deep-cocoa/40 focus:outline-none focus:ring-2 focus:ring-champagne-gold focus:border-transparent transition-all" required data-id="element-64" />
            <p className="text-xs text-deep-cocoa/60 mt-1.5" data-id="element-65">
              Aquí recibirás el acceso a tu guía
            </p>
          </div>

          {/* WhatsApp Field (Optional) */}
          <div data-id="element-66">
            <label htmlFor="whatsapp" className="block text-sm font-medium text-deep-cocoa mb-1.5" data-id="element-67">
              WhatsApp{' '}
              <span className="text-deep-cocoa/50 font-normal" data-id="element-68">(opcional)</span>
            </label>
            <input type="tel" id="whatsapp" name="whatsapp" value={formData.whatsapp} onChange={handleChange} placeholder="55 1234 5678" className="w-full px-4 py-3 bg-almond-milk border border-transparent rounded-lg text-deep-cocoa placeholder:text-deep-cocoa/40 focus:outline-none focus:ring-2 focus:ring-champagne-gold focus:border-transparent transition-all" data-id="element-69" />
            <p className="text-xs text-deep-cocoa/60 mt-1.5" data-id="element-70">
              Para soporte directo si lo necesitas
            </p>
          </div>

          {/* Stripe Payment Element Container */}
          <div className="pt-2" data-id="element-71">
            <label className="block text-sm font-medium text-deep-cocoa mb-3" data-id="element-72">
              Información de pago
            </label>

            {/* This is where Stripe Elements will be mounted */}
            <div id="payment-element" className="min-h-[120px] p-4 bg-almond-milk rounded-lg border border-deep-cocoa/10" data-id="element-73">
              {/* Stripe PaymentElement will be injected here via JavaScript */}
              <div className="flex items-center justify-center h-full text-sm text-deep-cocoa/50" data-id="element-74">
                Stripe Payment Element se cargará aquí
              </div>
            </div>

            <div className="flex items-center gap-2 mt-3 text-xs text-deep-cocoa/70" data-id="element-75">
              <LockIcon className="w-3.5 h-3.5 text-champagne-gold" data-id="element-76" />
              <span data-id="element-77">
                Tus datos están protegidos con cifrado de nivel bancario
              </span>
            </div>
          </div>
        </form>
      </div>
    </section>;
}